import { render, staticRenderFns } from "./DeleteDomainDialog.vue?vue&type=template&id=3053d1c8&scoped=true"
import script from "./DeleteDomainDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDomainDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053d1c8",
  null
  
)

export default component.exports